import { clsx, type ClassValue } from "clsx";
import { DateTime as dayjs, ConfigType as DateInput } from "@/core/date/DateTime";
import { twMerge } from "tailwind-merge";

export function getCookie(name: string): string | null {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split("=");
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isAnyKatakana(text: string) {
  return /^[\u30A0-\u30FF\uFF65-\uFF9F]+$/.test(text);
}

export function showDateTime(date: DateInput) {
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
}
